import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, inject, OnDestroy } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { boxInfo } from '../../../../modal/boxInfo';
import { Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';
import {MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../dialog/confirmdialog.component';
import { fromEvent, Subscription, combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AlertaService } from '../../../../utilidades/alerta.service';
import { RelatorioService } from '../../../../service/relatorio.service';
import { relatorio } from '../../../../modal/relatorio';
@Component({
  selector: 'app-cadastro-listagem-relatorio',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatCardModule,
    MatMenuModule,
    CommonModule,
    RouterLink,
    RouterOutlet,
    RouterModule,
    FormsModule,
    MatPaginatorModule
  ],
  templateUrl: './cadastro-listagem-relatorio.component.html',
  styleUrl: './cadastro-listagem-relatorio.component.scss'
})

export class CadastroListagemRelatorioComponent implements OnInit, OnDestroy {
  data = [];
  public listaInd: relatorio[] = [];
  pesquisaDesc: string  = "";
  pesquisaEtapa: string  = "";
  pesquisaCodigo: number | undefined = undefined;

  pageIndex = 0;
  pageSize = 10;
  totalPages = 1;
  pageSizeOptions = [5, 10, 25];

  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;

  subeButtonAdd= false;
  private sub?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private relatorioService: RelatorioService, public alertaService: AlertaService,
    public dialog: MatDialog) {
      const resize$ = fromEvent(window, 'resize').pipe(
        map(() => window.innerWidth), // pega largura da tela
        startWith(window.innerWidth)  // emite o valor inicial
      );
  
      this.sub = combineLatest([
        this.alertaService.isVisivel(),
        resize$
      ]).subscribe(([visivel, largura]) => {
        console.log('Alerta visível?', visivel, '| Largura da tela:', largura);
  
        if (visivel && largura < 570) {
          this.subeButtonAdd = true;
        } else {
          this.subeButtonAdd = false;
        }
      });
    try {
      let login = localStorage.getItem('login');
      if (login == null || login == undefined)
        this.router.navigate(['/iniciar']);
    }
    catch (ex) {
      this.router.navigate(['/iniciar']);
    }
  }

  ngOnInit() {
    this.Pesquisa();
  }

  MudaFiltro()
  {
    this.pageIndex =0;
    this.Pesquisa()
  }

  Pesquisa() {
    this.listaInd = [];
    this.relatorioService.getPaginacao(this.pageIndex, this.pageSize,this.pesquisaDesc, this.pesquisaCodigo, this.pesquisaEtapa).pipe(
    ).subscribe((response) => {
      this.data = response["Relatorio"];
      this.totalPages = response["totalPages"];
      let i = 0;
      console.log(response);
      this.data.forEach(element => {
        i++;
        let p = new relatorio(
          element['id'],
        element['codigo'],
        element['etapa'],
        element['proximaEtapa'],
        element['nome'],
        element['descricao'],
        element['icone'],
        element['consulta'],
        element['colecao'],);
        this.listaInd.push(p)
      });
    });
  }

  pageEvent: PageEvent | undefined;

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.totalPages = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    this.Pesquisa();
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
    }
  }

  InativarItem(id: string | null): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: { title: 'Confirmação', message: 'Tem certeza que deseja inativar?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (id != undefined) {
          this.relatorioService.deleteItem(id?.toString()).subscribe(
            (response) => {
              console.log('Item inativado com sucesso!');
              this.Pesquisa();
            },
            (error) => {
              console.error('Erro ao inativar o item:', error);
            }
          );
        }
      }
    });

  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
